import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import {
  boolean,
  index,
  jsonb,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { events } from './events';

/** Vídeo anexado pelo painel: arquivo enviado (`file`) ou link colado (YouTube/Instagram). */
export type TestimonialVideo = {
  kind: 'file' | 'youtube' | 'instagram';
  url: string;
  posterUrl?: string | null;
  /** Segundos. */
  duration?: number | null;
};

export const testimonials = pgTable(
  'testimonials',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    name: text('name').notNull(),
    text: text('text').notNull(),
    photoUrl: text('photo_url'),
    // Home do site mostra os `HOME_LIMIT` marcados mais recentes.
    showOnHome: boolean('show_on_home').notNull().default(false),
    video: jsonb('video').$type<TestimonialVideo>(),
    eventId: uuid('event_id')
      .references(() => events.id)
      .notNull(),
    // IP de quem enviou pelo site — só pro limite de envios (`PublicTestimonialService`), não sai na API.
    ip: text('ip'),
    isActive: boolean('is_active').default(true),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
    updatedAt: timestamp('updated_at')
      .$onUpdate(() => new Date())
      .notNull(),
    ...softDelete,
  },
  (t) => [index('testimonials_event_id_idx').on(t.eventId)],
);

export const testimonialsRelations = relations(testimonials, ({ one }) => ({
  event: one(events, {
    fields: [testimonials.eventId],
    references: [events.id],
  }),
}));

export type Testimonial = InferSelectModel<typeof testimonials>;
export type CreateTestimonialInput = InferInsertModel<typeof testimonials>;
export type UpdateTestimonialInput = Partial<CreateTestimonialInput>;
